(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ConsumerBooking',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.passenger-new-or-existing').change(function adjustedNewOrExisting() {
			if ($(this).val() === 'new') {
				$(this).parents('p').next().find(".pre-selected-client-typeahead").css('text-decoration', 'line-through');
				$(this).parents('p').next().find(".toggle-client-name").css('visibility', 'hidden');
				$(this).parents('p').next().find(".reset-typeahead").find('a').trigger('click');
				$(this).parents('p').next().find(".existing-client").prop('disabled', true);
			} else {
				$(this).parents('p').next().find(".pre-selected-client-typeahead").css('text-decoration', 'none');
				$(this).parents('p').next().find(".toggle-client-name").css('visibility', 'visible');
				$(this).parents('p').next().find(".existing-client").prop('disabled', false);
			}
		});
	};

}(jQuery, window.Adzuki || {}));
